// extracted by mini-css-extract-plugin
export default {"empty_text":"Empty_empty_text__IEBjL","empty_tips":"Empty_empty_tips__kmipR","empty_img":"Empty_empty_img__05Tfk"};